// Dynamic configuration for Unlock Request date constraints
import moment from 'moment';

export const getMinAllowedDate = () => {
  const currentDate = new Date();
  return new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
};

export const isDateAllowed = (date) => {
  const checkDate = moment(date);
  const minDate = moment(getMinAllowedDate());
  return checkDate.isSameOrAfter(minDate, 'day');
};
